import axios from "axios";

export const getBackendBaseUrl = () => {
  if (typeof window !== "undefined" && window.location) {
    const host = window.location.hostname;
    if (host !== "localhost" && host !== "127.0.0.1" && !host.startsWith("192.168.")) {
      return window.location.origin;
    }
  }
  return (process.env.REACT_APP_BACKEND_URL || "http://localhost:8000").replace(/\/+$/, "");
};

export const getApiBaseUrl = () => {
  return `${getBackendBaseUrl()}/api`;
};

export const api = axios.create({
  baseURL: getApiBaseUrl(),
  withCredentials: true,
});

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}
